import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS } from "./translations";

const LanguageContext = createContext({ lang: "en", setLang: () => {}, t: TRANSLATIONS.en });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("aa_lang") || "en";
    } catch {
      return "en";
    }
  });

  const setLang = (next) => {
    setLangState(next);
    try {
      localStorage.setItem("aa_lang", next);
    } catch {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: TRANSLATIONS[lang] || TRANSLATIONS.en }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
